var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { Year } from '@/models/Year';
import DataTable from '@/components/data-table/DataTable';
import AddYearDialog from '@/views/Years/AddYearDialog';
import { Curriculum } from '@/models/Curriculum';
import { activeHtml, sanitizeString } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
let Years = class Years extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Years';
        this.selected = [];
        this.selectedYear = null;
        this.isCreatingYear = false;
        this.isShowingDialog = false;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('year.title', 1),
                plural: this.$tc('year.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: '/years/{id}',
                    transform: (name, year) => (year.is_current ? activeHtml(name) : name),
                },
                { text: this.$t('starts.title'), value: 'starts_at' },
                { text: this.$t('ends.title'), value: 'ends_at' },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/years/{id}',
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, year) => {
                        this.selectedYear = year;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            dropdown: [],
            model: new Year(),
        };
    }
    setActive(dataTable, year) {
        year.update({ is_current: true }).then((curriculum) => {
            dataTable.refresh();
        });
    }
    parseNoCurriculumMsg() {
        const msg = this.$t('year.noCurriculum')
            .toString()
            .replace('{ curriculumlink }', `<a class="curriculumLink" style="padding: 0px 8px;" href="/curricula"> ${this.$tc('curriculum.title', 1)} </a> `);
        return `<i class="material-icons">warning</i> ${msg}`;
    }
    get dialogOptions() {
        const year = this.selectedYear;
        return {
            title: year.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.year') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!year) {
                            return;
                        }
                        year
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => { },
                },
            },
        };
    }
    mounted() {
        if (!this.$store.state.curriculum) {
            this.getCurrentCurriculum();
        }
    }
    getCurrentCurriculum() {
        new Curriculum()
            .include(['subjects', 'children'])
            .current()
            .first()
            .then((curriculum) => {
            this.$store.dispatch('loadedCurriculum', curriculum);
        })
            .catch((error) => { });
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
};
Years = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddYearDialog,
        },
    })
], Years);
export default Years;
